export default "__VITE_ASSET__CL5151pB__"